<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="true">
    <p style="color: white"> Please Wait Loading... </p>
</ngx-spinner>
<div class="app-body">
    <main class="main d-flex p-2">
        <div class="col-md-4 col-md-offset-4">

            <div class=" panel panel-default ">
                <div class="panel-body ">
                    <div class="text-center ">
                        <h3><i class="fa fa-lock fa-4x "></i></h3>
                        <h2 class="text-center ">You Are Logged Out!</h2>
                        <div class="panel-body ">
                            <div class="form-group">
                                <button class="btn btn-lg btn-primary " type="submit">Login in
                                    Again</button><br>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </main>
</div> -->
<div class="page-wrap d-flex flex-row align-items-center">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-12 text-center">
                <div class="mb-4 lead">
                    <div class="alert alert-success" role="alert">
                        You Have Successfully Logged Out Of The Application !!!
                    </div>
                </div>
                <button class="btn btn-primary loginButton" (click)="loginAgain()"><i class="fa fa-sign-in"
                        aria-hidden="true"></i>&nbsp;Login</button>
            </div>
        </div>
    </div>
</div>